/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Sent_Other_EmailInputs */



/**
* | output |
* | --- |
* | "Use a different email address" |
*
* @param {Login_Sent_Other_EmailInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const login_sent_other_email = /** @type {((inputs?: Login_Sent_Other_EmailInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Sent_Other_EmailInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Ander e-mailadres gebruiken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utiliser une autre adresse e-mail")
	return /** @type {LocalizedString} */ ("Use a different email address")
});